import Immutable from 'immutable';
import { ProjectId } from 'records/Project';

export type RFIFileType = 'FILE' | 'DRAWING' | 'IMAGE' | 'MARKUP';

export interface RawRFIFile {
  projectid: ProjectId;
  file: File;
  category: string;
  type: RFIFileType;
}

export interface RFIFileData {
  projectid: ProjectId;
  file: File;
  category: string;
  type: RFIFileType;
}

const defaultValues: RFIFileData = {
  projectid: '',
  file: new File([], ''),
  category: '',
  type: 'FILE',
};

export const RFIFileFactory = Immutable.Record(defaultValues, 'RFIFile');

export class RFIFile extends RFIFileFactory {
  static deserialize(rawRFIFile: RawRFIFile): RFIFile {
    return new RFIFile({
      ...rawRFIFile,
    });
  }

  serializeRFIFile(): RawRFIFile {
    return this.toJS();
  }
}
